import { Controller } from "@hotwired/stimulus"
import { Calendar } from "@fullcalendar/core"
import dayGridPlugin from "@fullcalendar/daygrid"
import lvLocale from "@fullcalendar/core/locales/lv"

export default class extends Controller {
  static values = {
    events: { type: Array, default: [] },
    locale: { type: String, default: "en" },
    worksheetsPath: { type: String, default: "/worksheets" },
    employeeId: { type: String, default: "" }
  }

  connect() {
    this.calendar = new Calendar(this.element, {
      plugins: [dayGridPlugin],
      initialView: "dayGridMonth",
      locale: this.localeValue === "lv" ? lvLocale : "en",
      headerToolbar: { left: "title", center: "", right: "prev,next" },
      events: this.eventsValue,
      height: "auto",
      fixedWeekCount: false,
      dayMaxEvents: true,
      eventContent: (arg) => ({ html: `<div class="fc-event-badge">${arg.event.title}</div>` }),
      eventClick: (info) => {
        const date = info.event.startStr
        const params = new URLSearchParams({ date_from: date, date_to: date })
        if (this.employeeIdValue) params.set("responsible_employee_id", this.employeeIdValue)
        window.location.href = `${this.worksheetsPathValue}?${params}`
      }
    })
    this.calendar.render()
  }

  disconnect() {
    this.calendar?.destroy()
  }
}
